<template>
  <div>
    <a-card
      class="mt-20"
      :bordered="false"
    >
      <!-- 表格筛选 start -->
      <a-form layout="inline">
        <a-form-item class="mr-20">
          <a-input
            v-model="queryParam.keyWord"
            placeholder="搜索关键字"
            allowClear
          >
            <a-select
              slot="addonBefore"
              v-model="queryParam.searchType"
              placeholder="搜索类型"
              style="width: 120px"
            >
              <a-select-option
                :value="item.id"
                :key="item.id"
                v-for="item in dict.searchTypeDict"
              >{{ item.name }}</a-select-option>
            </a-select>
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button
            class="mr-10"
            type="primary"
            @click="handleFilter"
          >
            搜索
          </a-button>
          <a-button @click="handleReset">
            重置
          </a-button>
        </a-form-item>
      </a-form>
      <!-- 表格筛选 end -->
      <!-- 表格内容操作 start -->
      <div class="mt-20">
        <a-button
          type="primary"
          class="mr-20"
          @click="handleAdd"
        >新增模板</a-button>
      </div>
      <!-- 表格内容操作 end -->
      <!-- 表格 start -->
      <tcg-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        bordered
        class="mt-20"
      >
        <span
          slot="print_mode"
          slot-scope="text"
        >
          {{ text | valInDict(dict.printModeDict) }}
        </span>
        <span
          slot="action"
          slot-scope="text, record"
        >
          <a-button
            type="link"
            @click="handleEdit(record.template_id)"
          >修改</a-button>
          <a-button
            type="link"
            @click="handleDelete(record.template_id)"
          >删除</a-button>
        </span>
      </tcg-table>
      <!-- 表格 end -->
    </a-card>
  </div>
</template>

<script>
import { TcgTable } from '@/components'
import { getTemplatePre, getTemplateList, postTemplatesDel } from '@/api/print'

const defaultQueryParam = {
  searchType: 'name'
}

export default {
  name: 'PrintMould',
  components: { TcgTable },
  data() {
    return {
      queryParam: Object.assign({}, defaultQueryParam),
      // 字典
      dict: {
        searchTypeDict: [{ id: 'name', name: '名称' }],
        printModeDict: []
      },
      columns: [
        {
          title: '模板名称',
          dataIndex: 'name'
        },
        {
          title: '打印方式',
          dataIndex: 'print_mode',
          scopedSlots: { customRender: 'print_mode' }
        },
        {
          title: '尺寸（mm）',
          dataIndex: 'size'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time'
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return getTemplateList(Object.assign(parameter, this.queryParam)).then((res) => {
          return res
        })
      }
    }
  },
  created() {
    this.getPre()
  },
  methods: {
    handleFilter() {
      this.$refs.table.refresh(true)
    },
    handleReset() {
      this.queryParam = Object.assign({}, defaultQueryParam)
      this.$refs.table.refresh(true)
    },
    handleAdd() {
      this.$router.push({ name: 'printMouldAdd' })
    },
    handleEdit(id) {
      this.$router.push({ name: 'printMouldEdit', query: { id: id } })
    },
    // 预加载
    getPre() {
      getTemplatePre()
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.dict.printModeDict = data.printModeDict
          }
        })
        .catch((e) => {
          this.$message.error('请求预加载失败')
        })
    },
    // 删除
    handleDelete(id) {
      this.$confirm({
        title: '确定要删除模板?',
        onOk: () => {
          postTemplatesDel({
            template_id: id
          })
            .then((res) => {
              if (res.code === 200) {
                this.$message.success('删除成功')
                this.$refs.table.refresh(true)
              }
            })
            .catch((e) => {
              this.$message.error('删除失败')
            })
        }
      })
    }
  }
}
</script>
